import React from "react";
import {
  DataGrid,
  Editing,
  Column,
  Paging,
  Pager,
  Lookup,
  Button as GridButton,
} from "devextreme-react/data-grid";
import uiInfo from "../ui-info";
import PaginaToolbar from "../components/PaginaToolbar";
import { criarLogradouroDs } from "../DataSources";
import UserInfo from "../UserInfo";
import Form, { SimpleItem, Label } from "devextreme-react/form";
import { Button } from "devextreme-react";

export default class LogradourosBox extends React.Component {
  constructor(props) {
    super(props);
    this.initNewRow = this.initNewRow.bind(this);
    this.state = {
      filtroCorrente: [],
      filtro: {},
    };
    this._gridInstance = React.createRef();
    this.filtrar = this.filtrar.bind(this);
    this.limparFiltro = this.limparFiltro.bind(this);
    this.onSelecionado = props.onSelecionado;
    this.usadoComoPesquisa = props.onSelecionado !== undefined;

    this.nomeOficialOptions = [
      { id: 0, descricao: "Não" },
      { id: 1, descricao: "Sim" }
    ]
  }

  filtrar(e) {
    let filtro = this.state.filtro;
    console.log("filtro", filtro);

    let filtroCorrente = [];
    if (filtro !== undefined) {
      if (filtro.tipo !== null && filtro.tipo !== undefined) {
        filtroCorrente.push(["tipo", "contains", filtro.tipo]);
      }

      if (filtro.sequencial !== null && filtro.sequencial !== undefined) {
        filtroCorrente.push(["sequencial", "=", filtro.sequencial]);
      }

      if (filtro.nome !== null && filtro.nome !== undefined) {
        filtroCorrente.push(["nome", "contains", filtro.nome]);
      }
      
    }
    this._gridInstance.instance.filter(
      filtroCorrente.length > 0 ? filtroCorrente : null
    );
  }

  limparFiltro(e) {
    this.setState({ filtro: {} });
    this.filtrar();
  }

  render() {
    return (
      <div className={"content-block dx-card responsive-paddings"}>
        <form onSubmit={this.filtrar}>
          <Form
            id="frmPesquisa"
            formData={this.state.filtro}
            colCount={6}
            labelLocation={"top"}
          >
            <SimpleItem dataField="tipo" colSpan={1}>
              <Label text="Tipo" />
            </SimpleItem>
            <SimpleItem dataField="sequencial" 
                editorType={"dxNumberBox"}
                colSpan={1}
                editorOptions={{ step: 0, value: null }}>
              <Label text="Código" />
            </SimpleItem>
            <SimpleItem dataField="nome" colSpan={4}>
              <Label text="Nome" />
            </SimpleItem>
          </Form>
          <br />
          <div
            style={{
              marginTop: "10px",
              display: "flex",
              justifyContent: "center",
            }}
          >
            <div style={{ display: "inline-block" }}>
              <Button
                width={120}
                text="Filtrar"
                type="success"
                onClick={this.filtrar}
              />
            </div>
            <div style={{ display: "inline-block", marginLeft: "10px" }}>
              <Button text="Limpar Filtro" onClick={this.limparFiltro} />
            </div>
          </div>
        </form>
        <br />
        <br />
        <PaginaToolbar titulo="LOGRADOUROS">
          <DataGrid
            ref={(grid) => (this._gridInstance = grid)}
            dataSource={criarLogradouroDs()}
            showBorders={true}
            rowAlternationEnabled={true}
            remoteOperations={true}
            wordWrapEnabled={true}
            columnAutoWidth={true}
            focusedRowEnabled={true}
            onInitNewRow={this.initNewRow}
          >
            <Editing
              mode={"row"}
              allowAdding={false}
              allowUpdating={true}
              allowDeleting={true}
            />
            <Column
              type="buttons"
              fixed={true}
              fixedPosition={"left"}
              allowEditing={false}
              width={140}
            >
              <GridButton name="edit" visible={!this.usadoComoPesquisa} />
              <GridButton name="delete" visible={!this.usadoComoPesquisa} />
              <GridButton
                hint="Selecionar"
                icon="repeat"
                visible={this.usadoComoPesquisa}
                onClick={this.onSelecionado}
              />
            </Column>
            <Column
              dataField={"sequencial"}
              allowEditing={false}
              alignment={"center"}
              width={80}
              caption={"#"}
            />
            <Column dataField={"tipo"} caption={"Tipo"} width={150} />
            <Column
              dataField={"codigoMunicipal"}
              caption={"Cód. Municipal"}
              width={150}
            />
            <Column
              dataField={"nomeAnterior"}
              wordWrapEnabled={true}
            />
            <Column
              dataField={"nome"}
              wordWrapEnabled={true}
            />
            <Column dataField={"nomeOficial"}>
                <Lookup dataSource={this.nomeOficialOptions} displayExpr={"descricao"} valueExpr={"id"} />
              </Column>
            <Column
              dataField={"lei"}
              wordWrapEnabled={true}
            />
            <Paging defaultPageSize={uiInfo.tamanhoPaginaPadrao} />
            <Pager
              showPageSizeSelector={true}
              allowedPageSizes={uiInfo.tamanhoPaginaOpcoes}
            />
          </DataGrid>
        </PaginaToolbar>
      </div>
    );
  }

  initNewRow(e) {
    e.data.prefeituraId = UserInfo.getPrefeitura();
  }
}
